import React from 'react'

function Navbar() {
  return (
    <section className='bg-[#dfdfdf] h-[10vh] flex justify-center items-center rounded-xl border border-[#c2c2c2]'>
    
    <div className='text-xl font-medium text-black'>Sorting Visualizer</div>
    
    </section>
  )
}

export default Navbar